/**
 * Материал Email and Web Pack (ТЗ §6, режим 12).
 *
 * Адреса и ссылки собираются из шаблонов, а не из настоящих доменов и
 * почтовых ящиков: чужой адрес в упражнении — это чужие данные, и попасть
 * туда он не может даже случайно. Домены взяты из зарезервированных под
 * примеры (ТЗ FR-EN-23, RFC 2606), локальные части — обобщённые: `user`, `info`,
 * `no-reply`. Такой адрес не существует ни у кого.
 *
 * Группы идут от ядра адреса к разделителям и дальше к схеме ссылки: пока
 * не набирается `user@example.com`, тренировать `https://` нечего.
 */

/** Группы токенов в порядке открытия. */
export const EMAIL_WEB_GROUPS: readonly (readonly string[])[] = [
  ['@', '.'],
  ['-', '_'],
  [':', '/'],
];

/**
 * Домены, отведённые под примеры (RFC 2606 §3).
 *
 * Проверяется тестом: адрес вне этого списка означал бы настоящий домен в
 * учебном материале.
 */
export const RESERVED_DOMAINS: readonly string[] = ['example.com', 'example.org', 'example.net'];

/** Адреса и ссылки, внутри которых тренируются токены. */
export const EMAIL_WEB_TEXTS: readonly string[] = [
  'user@example.com',
  'info@example.org',
  'admin@example.net',
  'first.last@example.com',
  'no-reply@example.org',
  'help-desk@example.net',
  'user_name@example.com',
  'first_last@example.org',
  'https://example.com',
  'https://example.org/docs',
  'http://example.net/a/b',
  'https://docs.example.com/guide',
  'https://example.org/user_guide',
  'https://help-desk.example.net/faq',
  // Материал, добавленный ради разнообразия (этап ABM): четырнадцати адресов
  // на весь режим хватало на два занятия. Домены — только отведённые под
  // примеры (RFC 2606 §3).
  'sales@example.com',
  'support@example.org',
  'team@example.net',
  'news@example.com',
  'office@example.org',
  'orders@example.net',
  'john.doe@example.com',
  'anna.smith@example.org',
  'max.power@example.net',
  'first-last@example.com',
  'help-line@example.org',
  'new-user@example.net',
  'user_one@example.com',
  'test_user@example.org',
  'my_name@example.net',
  'a.user@example.com',
  'b_user@example.org',
  'c-user@example.net',
  'https://example.net',
  'https://example.com/faq',
  'https://example.org/help',
  'http://example.com/news',
  'http://example.org/docs/api',
  'https://example.net/a/b/c',
  'https://mail.example.com',
  'https://news.example.org',
  'https://shop.example.net',
  'https://example.com/user_guide',
  'https://example.org/new-page',
  'https://example.net/docs/first_steps',
  'https://help.example.com/start',
  'https://api.example.org/v1/users',
  'https://files.example.net/data/raw',
  'https://example.com/blog/first-post',
  'https://team.example.org/about_us',
  'https://example.net/faq/how-to',
  'https://docs.example.com/guide/setup',
  'https://example.org/help-desk/new',
];
